<template>
  <v-dialog
    :value="productId"
    :fullscreen="$vuetify.breakpoint.xs"
    max-width="900px"
    class="rounded-lg"
    @click:outside="$emit('close')"
    @keydown.esc="$emit('close')"
  >
    <v-card
      class="rounded-lg"
      light
    >
      <v-toolbar
        dark
        absolute
        color="rgba(0,0,0,0)"
        width="100%"
        flat
      >
        <v-btn
          icon
          @click="$emit('close')"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-toolbar>

      <pictures
        :images="item.images"
        :wide="true"
        :options="(options.inspect || {}).carousel"
      />        
      <v-card-title
        class="font-weight-bold mb-1"
      >
        {{ item.name }}
        <v-spacer />
        <price
          :show="!subscription.enabled"
          :currency-icon="item.currency_icon"
          :price="price"
          :shipping="item.shipping"
        />
      </v-card-title>
      <v-card-text
        class="pa-0"
      >
        <v-row
          class="d-flex flex-row flex-nowrap justify-space-between px-5"
        >
          <div class="px-5 my-4 subtitle-1 black--text">
            {{ item.description }}
          </div>
        </v-row>

        <add-to-cart
          v-if="!subscription.enabled"
          :item="item"
          v-on="$listeners"
        />
        
        <buy-now
          v-if="subscription.enabled"
          :item="item"
          @one-time="oneTime"
          v-on="$listeners"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Pictures from './Pictures'
import AddToCart from './AddToCart'
import BuyNow from './buy_now/Index'
import Price from './Price'

export default {
  components: {
    Pictures,
    AddToCart,
    BuyNow,
    Price
  },
  props: {
    productId: {
      type: String,
      default: ()=>null
    },
    options: {
      type: Object,
      default: ()=>{return {}}
    },
  },
  data(){
    return {
      item: {},
      subscriptionOneTime: null
    }
  },
  computed: {
    subscription(){return this.item.subscription || {}},
    isSubscription(){return this.subscription.enabled},
    price(){return (this.item.properties || {}).price}
  },
  watch: {
    productId(){
      this.fetch()
    },
    show(opening){
      if (!opening) {
        this.$emit('close')
      }
    }
  },
  mounted(){
    this.fetch()
  },
  methods: {
    oneTime(v){
      this.subscriptionOneTime = v
    },
    async fetch(){
      if (this.productId) {
        this.item = await this.api.get(`/product/product/${this.productId}`)
      }
    }
  }
}
</script>
